@if(service.isEditing()) {
<h2 mat-dialog-title>
  <svg class="icon-24 modal-icon"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
  Rediger lokation
</h2>
} @else {
<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
  Opret lokation
</h2>
}

<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <adm-loading-spinner [loading$]="loading$"></adm-loading-spinner>

  @if (loading$.getValue() === false) {
  <form [formGroup]="locationForm">
    <adm-form-accordion>
      <ng-template admFormAccordionPanel title="Tilhørsforhold" [formGroup]="step1">
        <adm-csl-step1 [form]="step1" />
      </ng-template>

      <ng-template admFormAccordionPanel title="Lokationsoplysninger" [formGroup]="step2">
        <adm-csl-step2
          [form]="step2"
          [initialAddress]="initialAddress()"
          [noValidNetArea]="showNoValidNetAreaWarning()"
          [checkingNetArea]="netAreaCheckPending()" />
      </ng-template>

      <ng-template admFormAccordionPanel title="Standarder og faciliteter" [formGroup]="step3">
        <adm-csl-step3
          [form]="step3"
          [organizationId]="step1.controls.organizationId.value"
          [canHaveDynamicPricePolicy]="effectiveCanHaveDynamicPricePolicy()"
          [hasOkPowerMeter]="step2.controls.hasOkPowerMeter.value ?? false"
          [pricePolicyChangeRequired]="pricePolicyChangeRequired()"
          [netAreaRemoved]="netAreaRemoved()"
          [okPowerMeterChangedFromYes]="initialHasOkPowerMeter && !step2.controls.hasOkPowerMeter.value"
          [pricePolicyResetTrigger]="pricePolicyResetTrigger()"
          (pricePolicySelected)="onPricePolicySelected($event)" />
      </ng-template>

      <ng-template admFormAccordionPanel title="Fakturering" [formGroup]="step4">
        <adm-csl-step4 [form]="step4" [hasOkPowerMeter]="step2.controls.hasOkPowerMeter.value ?? false" />
      </ng-template>
    </adm-form-accordion>
  </form>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (service.isEditing()) { @let details = locationDetails$ | async; @if( details?.chargingStationLocationRelationId && details){
  <div class="unit-identifier">
    <span>Lokation:</span>
    {{ details.chargingStationLocationName }}
  </div>
  } }
  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
  <button
    class="actions__button"
    type="button"
    mat-flat-button
    color="primary"
    [disabled]="(isFormValid$ | async) === false || service.saving() || netAreaCheckPending()"
    [class.spinner]="service.saving()"
    (click)="handleSave()">
    {{ service.isEditing() ? 'Gem' : 'Opret' }}
  </button>
</mat-dialog-actions>
